import { createContext, useContext } from 'react'

export const ApplicationContext = createContext({
    application: undefined,
    profile: undefined,
    location: undefined,
    communication: undefined,
    answers: [],
    householdMembers: [],
    documents: [],
    benefits: [],

    setApplication: (application: any) => {
        console.error('Context not implemented')
    },
    setProfile: (person: any) => {
        console.error('Context not implemented')
    },
    setLocation: (location: any) => {
        console.error('Context not implemented')
    },
    setCommunication: (communication: any) => {
        console.error('Context not implemented')
    },
    setAnswers: (answers: any[]) => {
        console.error('Context not implemented')
    },
    setHouseholdMembers: (householdMembers: any[]) => {
        console.error('Context not implemented')
    },
    setDocuments: (documents: any[]) => {
        console.error('Context not implemented')
    },
    setBenefits: (benefits: any[]) => {
        console.error('Context not implemented')
    },
})
ApplicationContext.displayName = 'ApplicationContext'

export const useApplication = () => useContext(ApplicationContext)
